<soft-master-detail-page
  backNavigationPath="/"
  [masterTemplate]="masterTemplate"
  [detailTemplate]="detailTemplate"
  [(activeItem)]="selectedHardware"
  [items]="(hardwareData$ | async | sort: 'autoid' : (sort$ | async)) ?? []"
  [idFunction]="idFunction"
>
  <ng-template let-data #masterTemplate>
    <div
      class="flex flex-col font-sans text-sm pl-2 md:pl-0 lg:pl-2 py-2"
    >
      <span class="text-xs soft-overline !mb-0">Id: {{ data?.autoid }}</span>
      <div class="flex flex-row justify-between font-sans">
        <h6 class="font-semibold">{{ data?.hostname || data?.produkt?.produkt }}</h6>
      </div>

      <div class="flex items-center gap-2 font-sans opacity-75 mt-0.5">
        <i class="fa-regular fa-screwdriver-wrench"></i>
        {{ data?.hardwaretyp?.typ }}
      </div>
      @if (data?.benutzer) {
        <div class="flex items-center gap-2 font-sans opacity-75">
          <i class="fa-regular fa-user"></i>
          {{ data?.benutzer }}
        </div>
      }
    </div>
  </ng-template>

  <ng-template #detailTemplate>
    <soft-hardware-details
      [isOnlyView]="false"
      [hardware]="selectedHardware$ | async"
    ></soft-hardware-details>
  </ng-template>
</soft-master-detail-page>

<ng-template #detailPlaceholder>
  <div class="flex h-full flex-1 w-full items-center justify-center text-center px-10">
    {{ '#HARDWARE_MANAGEMENT.PAGES.RESULTS.DETAIL_PLACEHOLDER' | translate }}
  </div>
</ng-template>

<ng-template #testFooter>
  <button class="soft-button primary rounded-lg h-14 m-2">
    Test Button
  </button>
</ng-template>

<!--
<soft-page #page>
  <soft-page-header>
    <div class="flex flex-col w-full md:flex-row justify-between items-center">
      @if ({ query: query$ | async }; as queryData) {
        @if (true) {
          <div class="flex flex-col items-center">
            <soft-chip-group class="w-full flex flex-row pb-4 md:pb-0">
              @for (data of queryData.query; track data) {
                <soft-chip
                  (delete)="removeQuery(data.key)"
                  class="!w-auto"
                  [canDelete]="true"
                >
                  <strong>{{ data?.name }}:</strong> {{ data.value }}
                </soft-chip>
              }
            </soft-chip-group>
          </div>
          <div
            [ngClass]="{
            hidden: ((selectedHardware$ | async) ?? undefined) !== undefined,
          }"
            class="flex w-full md:w-72 xl:w-96 sm:flex items-center"
          >
            <soft-input
              (valueChange)="searchText$.next($event ?? '')"
              placeholder="Suche"
            ></soft-input>
            <div
              class="flex content-center items-center ml-3 text-lg cursor-pointer font-semibold"
            >
              @if ((sort$ | async) === 'DESC') {
                <div (click)="sort$.next('ASC')">
                  <i class="fa-regular fa-arrow-up-long"></i>
                </div>
              }
              @if ((sort$ | async) === 'ASC') {
                <div (click)="sort$.next('DESC')">
                  <i class="fa-regular fa-arrow-down-long"></i>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </soft-page-header>

  <soft-page-panel panelRole="master" panelStyle="plain" class="overflow-y-auto">
    @let selectedHardware = (selectedHardware$ | async);

    @for (hardware of hardwareData$ | async | sort: 'autoid' : (sort$ | async); track hardware.autoid) {
      <div class="min-h-auto! hover:bg-hover my-1 rounded-lg overflow-clip grow-0!"
        [class.soft-panel-grouped]="selectedHardware?.autoid === hardware.autoid"
        [class.bg-surface-tertiary]="selectedHardware?.autoid !== hardware.autoid"
        (click)="selectionChanged(hardware); page.visiblePanelRoles().length === 1 && page.visiblePanelRoles()[0] === 'master' ? page.visiblePanelRoles.set(['detail']) : page.visiblePanelRoles.set(page.visiblePanelRoles())"
      >
        <ng-container *ngTemplateOutlet="masterTemplate; context: { $implicit: hardware, data: hardware }"></ng-container>
      </div>
    }
  </soft-page-panel>

  <soft-page-panel panelRole="detail" panelStyle="plain" class="overflow-y-auto">
    <soft-page-panel-header>
      <button (click)="page.visiblePanelRoles().length === 1 && page.visiblePanelRoles()[0] === 'detail' ? page.visiblePanelRoles.set(['master']) : page.visiblePanelRoles.set(page.visiblePanelRoles())">
        <- Test header mit back
      </button>
    </soft-page-panel-header>

    <soft-hardware-details
      [isOnlyView]="false"
      [hardware]="selectedHardware$ | async"
    ></soft-hardware-details>
  </soft-page-panel>
</soft-page> -->






<!--
<soft-page [blockScrollY]="false" customClass="!p-0">
  <soft-page-header #header>
    <div class="flex flex-col w-full md:flex-row justify-between items-center">
      @if ({ query: query$ | async }; as queryData) {
        @if (masterDetail.view() !== 'detail') {
          <div class="flex flex-col items-center">
          <soft-chip-group class="w-full flex flex-row pb-4 md:pb-0">
            @for (data of queryData.query; track data) {
              <soft-chip
                (delete)="removeQuery(data.key)"
                class="!w-auto"
                [canDelete]="true"
                >
                <strong>{{ data?.name }}:</strong> {{ data.value }}
              </soft-chip>
            }
          </soft-chip-group>
        </div>
        <div
            [ngClass]="{
              hidden: ((selectedHardware$ | async) ?? undefined) !== undefined,
            }"
          class="flex w-full md:w-72 xl:w-96 sm:flex items-center"
          >
          <soft-input
            (valueChange)="searchText$.next($event ?? '')"
            placeholder="Suche"
          ></soft-input>
          <div
            class="flex content-center items-center ml-3 text-lg cursor-pointer font-semibold"
            >
            @if ((sort$ | async) === 'DESC') {
              <div (click)="sort$.next('ASC')">
                <i class="fa-regular fa-arrow-up-long"></i>
              </div>
            }
            @if ((sort$ | async) === 'ASC') {
              <div (click)="sort$.next('DESC')">
                <i class="fa-regular fa-arrow-down-long"></i>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</soft-page-header>

<soft-master-detail
  #masterDetail
  [data]="hardwareData$ | async | sort: 'autoid' : (sort$ | async)"
  (selectedChange)="selectionChanged($event)"
  [detailPlaceholder]="detailPlaceholder"
  [masterTemplate]="masterTemplate"
  [detailTemplate]="detailTemplate"
  >
</soft-master-detail>
</soft-page>
-->


